
export default function (items) {
  const sortMap = {
    template: 0,
    page: 1,
    container: 2,
    feature: 3,
    widget: 4,
  };

  return items.sort((itemA, itemB) => {
    if (itemA.type === itemB.type) {
      return 0;
    }

    const sortA = sortMap[itemA.type];
    const sortB = sortMap[itemB.type];

    if (typeof sortA === 'undefined') {
      return -1;
    }

    if (typeof sortB === 'undefined') {
      return 1;
    }

    return (sortA < sortB) ? -1 : 1;
  });
}
